<div class="content-container mt-3 pt-2 scroll-id job-screen-container" id="orderDetails">
  <div class="order-list-header-bar">
    <h2 class="sub-header-bar" [ngClass]="{ 'header-top-margin': isJobInCreatedStatus(job) }">
      Order Details
    </h2>
    <button
      *ngIf="organisationTypeId == 1 && isJobInCreatedStatus(job)"
      type="button"
      pButton
      label="Order Sequencing"
      class="ui-button"
      (click)="editTaskSequence()"
    ></button>
  </div>
  <div>
    <div class="mt-2">
      <p-panel styleClass="no-padding-panel panel-shadow">
        <p-header>
          <div class="panel-header">Orders</div>
        </p-header>

        <ng-container [ngTemplateOutlet]="orderList"></ng-container>
      </p-panel>

      <job-screen-job-details
        [hideTaskSchedule]="job?.supplierId == null"
        [organisationTypeId]="organisationTypeId"
        [orderId]="selectedOrder?.id"
      ></job-screen-job-details>
    </div>
  </div>
</div>

<div
  class="content-container mt-3 pt-2 scroll-id job-screen-container"
  id="taskDetails"
  style="padding-left: 0px; padding-right: 0px"
>
  <div style="padding: 0 20px">
    <h2 class="sub-header-bar">Task Details</h2>
  </div>

  <job-screen-tasks
    [organisationId]="organisationId"
    [organisationTypeId]="organisationTypeId"
    [orderId]="selectedOrder.id"
    [jobId]="jobId"
    *ngIf="selectedOrder"
  ></job-screen-tasks>
</div>

<p-dialog
  header="Impersonate Customer"
  [(visible)]="showImpersonateCustomerDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>User</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="impersonateCustomerUsers"
          placeholder="Select user"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedImpersonateUser"
          appendTo="body"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12" style="margin-top: 20px">
      <button
        type="button"
        (click)="showImpersonateCustomerDialog = false"
        pButton
        label="Close"
        class="ui-button btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        label="Impersonate"
        class="ui-button green-btn btn-to-right"
        (click)="impersonateCustomerConfirm()"
        [disabled]="!selectedImpersonateUser"
      ></button>
    </div>
  </div>
</p-dialog>

<ng-template #orderList>
  <p-table
    [value]="job?.orders"
    selectionMode="single"
    tableStyleClass="table-no-top-corners"
    styleClass="no-border-table table-no-bottom-corners"
    [(selection)]="selectedOrder"
    [responsive]="true"
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="break-word" *ngIf="orderSequencingEnabled" style="width: 100px">Sequence</th>
        <th class="break-word">Order Number</th>
        <th class="break-word" style="width: 100px">Vehicles</th>
        <th class="break-word" *ngIf="organisationTypeId != 3">Customer</th>
        <th class="break-word" style="width: 100px" *ngIf="organisationTypeId != 3">Price</th>
        <th class="break-word" *ngIf="organisationTypeId == 1">Quote</th>
        <th class="break-word" *ngIf="organisationTypeId == 1">Expense Inclusivity</th>
        <th
          class="break-word"
          *ngIf="organisationTypeId != 3 && jobHasOrdersWithInspectAndCollect()"
        >
          Inspection Charge
        </th>
        <th class="break-word" *ngIf="organisationTypeId == 2">Cost Centre</th>
        <th class="break-word" *ngIf="allOrderTags.length > 0">Customer Tags</th>
        <th class="break-word po-number-cell" *ngIf="allPurchaseNumbers.length > 0">PO Number</th>

        <!--
        <th class="break-word">Status</th>
        -->

        <th class="break-word" *ngIf="organisationTypeId != 3">Department</th>
        <th class="break-word" *ngIf="organisationTypeId != 3">Team</th>

        <th class="break-word">Movement Type</th>

        <th class="break-word" *ngIf="anyOrderCancelled">Cancel Status</th>
        <!--
        <th class="break-word" *ngIf="organisationTypeId == 1">Cancel Description</th>
        -->
        <!--
        <th class="break-word" *ngIf="organisationTypeId == 1">Channel</th>
        -->
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-orderUntyped>
      <ng-container *ngIf="asOrder(orderUntyped) as order">
        <tr [pSelectableRow]="order">
          <td class="break-word align-center" *ngIf="orderSequencingEnabled">
            {{ order.localOrderSequence }}
          </td>
          <td class="break-word text-center">
            <div>{{ order.orderNumber }}</div>
            <div
              class="status-chip mt-1"
              [class]="'status-chip-' + order.statusName?.toLowerCase()"
            >
              {{ order.statusName }}
            </div>
          </td>
          <td class="text-center">
            <div *ngFor="let regPlate of order.regPlates">
              {{ regPlate }}
            </div>
          </td>
          <td class="break-word" *ngIf="organisationTypeId != 3">
            {{ order.customer ? order.customer.name : '' }}
            <div *ngIf="organisationTypeId == 1">
              <span class="link-style cursor-pointer" (click)="showBookingInfoDialog(order, $event)"
                >{{ order.user?.firstName }} {{ order.user?.lastName }}</span
              >
              <span> - {{ order.requestChannel }}</span>
            </div>
          </td>
          <td class="break-word" *ngIf="organisationTypeId != 3">
            <span *ngIf="order.includedMilesFixed; else normalPrice">{{
              order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2'
            }}</span>
            <ng-template #normalPrice>
              <span *ngIf="order.isOverridePrice">{{
                order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2'
              }}</span>
              <span *ngIf="!order.isOverridePrice && isOrderCompletedOrCancelled(order)">{{
                order.transactionsPrice | currency : 'GBP' : 'symbol' : '1.2-2'
              }}</span>
              <span *ngIf="!order.isOverridePrice && !isOrderCompletedOrCancelled(order)"
                >{{ order.minPrice | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                {{ order.maxPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</span
              >
            </ng-template>
          </td>
          <td class="break-word" *ngIf="organisationTypeId == 1">
            <span *ngIf="order.includedMilesFixed; else normalQuote">{{
              order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2'
            }}</span>
            <ng-template #normalQuote>
              <span *ngIf="!order.isOverridePrice && order.minPrice && order.maxPrice"
                >{{ order.minPrice | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                {{ order.maxPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</span
              >
              <span *ngIf="order.isOverridePrice">
                <div>{{ order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</div>
                <div class="mt-1" *ngIf="order.orderQuote?.discountAmount > 0">
                  ({{ order.orderQuote?.discountAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}
                  Discount)
                </div>
              </span>
              <div *ngIf="organisationTypeId == 1 && order.customerPostcodePremium">
                <span class="font-bold">Postcode Premium: </span
                >{{ order.customerPostcodePremium | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </div>
            </ng-template>
          </td>
          <td class="break-word text-center" *ngIf="organisationTypeId == 1">
            {{ order.inclusivityType }}
          </td>
          <td
            class="break-word text-center"
            *ngIf="organisationTypeId != 3 && jobHasOrdersWithInspectAndCollect()"
          >
            <span>{{ order.inspectionCharge | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
          </td>
          <td class="break-word" *ngIf="organisationTypeId == 2">
            {{ order.accountCodeList ? order.accountCodeList.code : '' }}
          </td>
          <td class="break-word" *ngIf="allOrderTags.length > 0">
            {{ getCustomerTags(order.orderTags) }}
          </td>
          <td class="break-word text-center po-number-cell" *ngIf="allPurchaseNumbers.length > 0">
            <span class="po-number-value">{{ order.purchaseOrderNo }}</span>
          </td>
          <!--
        <td class="break-word">{{ getOrderStatus(order.statusId) }}</td>
        -->
          <td class="break-word text-center" *ngIf="organisationTypeId != 3">
            {{ order.customerDepartment ? order.customerDepartment.name : '' }}
          </td>
          <td class="break-word text-center" *ngIf="organisationTypeId != 3">
            {{ order.customerTeam ? order.customerTeam.name : '' }}
          </td>
          <td class="break-word text-center">{{ order.taskTypeName }}</td>
          <td class="break-word" *ngIf="anyOrderCancelled">
            <div [pTooltip]="order.cancellationDescription">
              <div>{{ order.cancellationStatusName }}</div>
              <div *ngIf="order.subCancellationStatus" class="mt-2">
                {{ order.subCancellationStatus.name }}
              </div>
            </div>
          </td>
          <!--
        <td class="break-word" *ngIf="organisationTypeId == 1">
          <div title="{{ order.cancellationDescription }}">
            {{ order.cancellationDescription }}
          </div>
        </td>
        -->
          <!--
        <td class="break-word" *ngIf="organisationTypeId == 1">
          <div title="{{ order.requestChannel.displayName }}">
            {{ order.requestChannel.displayName }}
          </div>
        </td>
        -->
          <!--        <td class="break-word" *ngIf="organisationTypeId == 1">-->
          <!--          <div (click)="showBookingInfoDialog(order, $event)">-->
          <!--            {{ order.user?.firstName }}-->
          <!--            {{ order.user?.lastName }}-->
          <!--            <i class="fa fa-info-circle"></i>-->
          <!--          </div>-->
          <!--        </td>-->
        </tr>
      </ng-container>
    </ng-template>
  </p-table>

  <div style="padding: 0.625em 1em">
    <div class="text-right">
      <button
        pButton
        *ngIf="isCancelOrderEnableForVME()"
        label="Cancel Order"
        class="ui-button ui-button-danger"
        (click)="showCancelOrderDialog = true"
      ></button>

      <button
        pButton
        *ngIf="selectedOrder?.orderQuote && !selectedOrder.orderQuote.invoiceCreated"
        label="Create Invoice"
        class="ui-button ui-button-tertiary"
        (click)="createOrderInvoice(selectedOrder)"
        [disabled]="creatingInvoice"
      ></button>

      <button
        type="button"
        *ngIf="organisationTypeId == 1"
        (click)="impersonateCustomer()"
        pButton
        label="Impersonate Customer"
        class="ui-button ui-button-tertiary"
        [disabled]="!selectedOrder || isImpersonating"
      ></button>

      <button
        *ngIf="organisationTypeId == 2 || organisationTypeId == 4"
        type="button"
        (click)="copyOrder(selectedOrder)"
        pButton
        label="Copy Order"
        class="ui-button ui-button-secondary"
        [disabled]="!selectedOrder"
      ></button>

      <!--      <button-->
      <!--        *ngIf="organisationTypeId == 1"-->
      <!--        type="button"-->
      <!--        (click)="onQuickCopyClick(selectedOrder)"-->
      <!--        pButton-->
      <!--        label="Copy Order"-->
      <!--        class="ui-button ui-button-tertiary"-->
      <!--        [disabled]="!selectedOrder"-->
      <!--      ></button>-->

      <button
        type="button"
        *ngIf="organisationTypeId == 1 || organisationTypeId == 2 || organisationTypeId == 4"
        (click)="showEditOrderDialog = true"
        pButton
        label="Edit"
        class="ui-button ui-button-primary"
        [disabled]="!selectedOrder || (isJobCompleted(job) && organisationTypeId != 1)"
      ></button>
    </div>
  </div>
</ng-template>

<vme-edit-order-dialog
  [(visible)]="showEditOrderDialog"
  [selectedOrder]="selectedOrder"
  [organisationTypeId]="organisationTypeId"
  [job]="job"
  (onSaveEditOrder)="onSaveEditOrder($event)"
></vme-edit-order-dialog>

<vme-cancel-order-dialog
  [jobId]="jobId"
  [orderId]="selectedOrder?.id"
  [(visible)]="showCancelOrderDialog"
  (onCancelled)="onOrderCancelled()"
>
</vme-cancel-order-dialog>

<p-dialog
  header="Booking Info"
  [(visible)]="showBookingInfo"
  [modal]="true"
  [style]="{ width: '560px' }"
  closable="true"
>
  <div style="padding-bottom: 10px; font-weight: bold; font-size: 1.2rem">Order Created By</div>

  <div style="text-align: left; padding-bottom: 10px; font-weight: bold">
    <i class="fa fa-user"></i> &nbsp; {{ currentOrder?.user?.firstName }}
    {{ currentOrder?.user?.lastName }}
  </div>

  <div style="text-align: left; font-weight: bold">
    <i class="fa fa-phone"></i>
    <a href="tel:{{ currentOrder?.user?.phoneNumber }}">
      &nbsp; {{ currentOrder?.user?.phoneNumber }}</a
    >
  </div>

  <div style="text-align: left; padding-top: 10px; font-weight: bold">
    <i class="fa fa-envelope"></i> &nbsp;
    <a href="mailto:{{ currentOrder?.user?.email }}">{{ currentOrder?.user?.email }}</a>
  </div>

  <div
    *ngIf="currentOrder?.customerTeam?.primaryContactEmail"
    style="padding-top: 10px; font-weight: bold"
  >
    <i class="fa fa-envelope"></i><span>Primary Contact Email:</span> &nbsp;
    <a href="mailto:{{ currentOrder?.customerTeam?.primaryContactEmail }}">{{
      currentOrder?.customerTeam?.primaryContactEmail
    }}</a>
  </div>

  <div *ngIf="currentOrder?.customerTeam?.primaryContactEmail" style="font-weight: bold">
    <i class="fa fa-envelope"></i><span>Secondary Contact Email:</span>
    &nbsp;
    <a href="mailto:{{ currentOrder?.customerTeam?.secondaryContactEmail }}">{{
      currentOrder?.customerTeam?.secondaryContactEmail
    }}</a>
  </div>

  <!--<div style="padding-top: 15px; padding-bottom: 10px; font-weight: bold; font-size: 1.2rem">
    Customer
  </div>

  <div>
    <div style="padding-bottom: 10px">
      <i class="fa fa-building"></i> &nbsp; {{ currentOrder?.customer?.name }}
    </div>
    <div style="padding-bottom: 10px; font-weight: bold">
      <i class="fa fa-phone"></i> &nbsp;
      <a href="tel:{{ currentOrder?.customer?.phoneNumber }}">{{
        currentOrder?.customer?.phoneNumber
      }}</a>
    </div>
  </div>-->
</p-dialog>

<app-task-sequencing-editor
  *ngIf="taskSequenceEditorVisible"
  [(visible)]="taskSequenceEditorVisible"
  (saveTaskSequence)="taskSequenceUpdated()"
  [jobId]="jobId"
  [displayCombineNotification]="directedFromCombine"
></app-task-sequencing-editor>
